export class Report {

    private report: Object;

    constructor(report: Object){
        this.report = report['report'];
    }

    getFailures(): Array<Object> {
        const failures: Array<any> = [];
        if(this.report.hasOwnProperty('check_failed')){
            let reportFailures: Object = this.report['check_failed'];
            for(let key in reportFailures){
                if(key.match(/vna/g)){
                    failures.push(reportFailures[key]);
                }
            }
        }

        return failures;
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/data/health/Report.ts